const dispatchState = {
    methods: {
        dispatchState(state) {
            this.$emit('change-state', { state });
        }
    }
};

export default dispatchState;
